import React from 'react';
import { SortableList } from '../../../components/HOCs/withDragAndDrop';

import './SortableLists.css';
import { getTranslation } from '../../../assets/creator/translations';

const getGetLists = (props) => {
    let dimensions = { header: 'calc(23.5vh - 15px)', body: 'calc(47vh - 30px)', footer: 'calc(23.5vh - 15px)' }
    const lists = [
        { groupName: 'header', listName: 'header', placeholder: getTranslation('Grp_Header'), minHeight: dimensions.header, items: props.header },
        { groupName: 'body', listName: props.bodyListName, placeholder: getTranslation('Grp_Content'), minHeight: dimensions.body, items: props.body },
        { groupName: 'footer', listName: 'footer', placeholder: getTranslation('Grp_Footer'), minHeight: dimensions.footer, items: props.footer }
    ];
    return () => (
        <React.Fragment>
            {lists.map((l) => (
                <SortableList
                    key={l.listName}
                    {...l /* spread all props */}
                    elementType={props.type}
                />
            ))}
        </React.Fragment>
    );
}

//Sortable lists is naming convention from react-dnd
//each sortable list is a part of displayed page, be it a header, a footer or a body (content)
const SortableLists = (props) => {
    const getLists = getGetLists(props);

    return getLists();
};

export default SortableLists;


// WEBPACK FOOTER //
// ./src/containers/Page/SortableLists/SortableLists.js